// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7021":"662dcf3a","7261":"6df52070"}[chunkId] + ".chunk.css";
};